import React, { useState } from "react"
import classNames from "classnames"
import { Checkbox, Space } from "antd"
import { Text } from "ui/Typography"
import { DAYS } from "../../utils/constants"
import styles from "./DaySelector.module.css"

const days = {
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false,
  sunday: false
}

export const DaySelector = ({ form, markedDays, handleMarkedDays }) => {
  const [enabledDays, setEnabledDays] = useState([])

  const handleEnabledDays = (day) => {
    const currentDays = [...enabledDays]
    let newDays = []
    if (currentDays.includes(day)) {
      newDays = currentDays.filter((d) => d !== day)
      setEnabledDays(newDays)
    } else {
      newDays = [...currentDays, day]
      setEnabledDays(newDays)
    }
    newDays.forEach((d) => (days[d] = true))
    form.setFieldsValue({ available_days: days })
  }

  return (
    <Space size="small" className={styles.daySelector}>
      {DAYS.map((day) => (
        <div key={day.value} className="flex-column align-center">
          <div
            className={classNames(styles.dayItem, markedDays.includes(day.value) && styles.selected)}
            onClick={() => handleMarkedDays(day.value)}
          >
            <Text varian="sub">{day.label}</Text>
          </div>
          <Checkbox
            checked={enabledDays.includes(day.value)}
            onChange={() => handleEnabledDays(day.value)}
            className={styles.dayCheckbox}
          />
        </div>
      ))}
    </Space>
  )
}

export default DaySelector
